export default __webpack_public_path__ + "static/media/Europe_08.6b56a70f.png";